{
  "version": 1,
  "asset_id": "d398e6ef-2bd4-457d-ad74-3b4c82315aa6",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/d398e6ef-2bd4-457d-ad74-3b4c82315aa6/hiatal-type-3-second-es-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/d398e6ef-2bd4-457d-ad74-3b4c82315aa6/hiatal-type-3-second-es-800.jpg",
  "original_filename": "hiatal-type-3-second-es-800.jpg",
  "size": 136802,
  "content_type": "image/jpeg",
  "created_at": "2026-09-26T23:53:40Z"
}
